import React from 'react'
import createSvgIcon from 'client/icons/createSvgIcon'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5.7 2H18.3C20.3 2 22 3.7 22 5.7V18.3C22 20.3 20.3 22 18.3 22H5.5C3.6 22 2 20.4 2 18.5V5.7C2 3.7 3.7 2 5.7 2ZM18.3 20C19.2 20 20 19.2 20 18.3V5.7C20 4.8 19.2 4 18.3 4H5.7C4.8 4 4 4.8 4 5.7V18.5C4 19.3 4.7 20 5.5 20H18.3ZM9 6.5H12.9C14.9 6.5 16.5 8.2 16.5 10.2C16.5 12.2 14.9 13.9 12.9 13.9H10V16.5C10 17.1 9.6 17.5 9 17.5C8.4 17.5 8 17.1 8 16.5V7.5C8 6.9 8.4 6.5 9 6.5ZM10 11.9H12.9C13.8 11.9 14.5 11.1 14.5 10.2C14.5 9.3 13.8 8.5 12.9 8.5H10V11.9Z"
  />,
  'CarPark'
)
